import type { HelpFile } from '../../types/help'
import { FunctionGroupRequestWizardTestIds } from '../../../testids/FunctionGroupRequestWizardTestIds'

export const functionGroupRequestWizardHelp: HelpFile = {
  docPage: '/docs/governance/function-groups',
  texts: {
    [FunctionGroupRequestWizardTestIds.functionGroupRequestWizardPage]: 'Assistent zum Beantragen von Zugriff über eine oder mehrere Funktionsgruppen für die eigene oder eine andere Identität.',
    [FunctionGroupRequestWizardTestIds.fgRequestStepContainer]: null,
    [FunctionGroupRequestWizardTestIds.btnCancel]: null,
    [FunctionGroupRequestWizardTestIds.btnCollapseAllFgs]: null,
    [FunctionGroupRequestWizardTestIds.btnCollapseAllReview]: null,
    [FunctionGroupRequestWizardTestIds.btnExpandAllFgs]: null,
    [FunctionGroupRequestWizardTestIds.btnExpandAllReview]: null,
    [FunctionGroupRequestWizardTestIds.btnNextStep]: null,
    [FunctionGroupRequestWizardTestIds.btnPreviousStep]: 'Zum vorherigen Schritt zurückkehren — die Auswahl bleibt erhalten.',
    [FunctionGroupRequestWizardTestIds.btnSelectMyself]: null,
    [FunctionGroupRequestWizardTestIds.btnSelectSomeoneElse]: null,
    [FunctionGroupRequestWizardTestIds.btnSubmitRequest]: 'Antrag zur Genehmigung einreichen — Genehmiger sehen jede ausgewählte Funktionsgruppe.',
    [FunctionGroupRequestWizardTestIds.cardTitleReviewAndSubmit]: 'Finale Prüfung des Antrags — Empfänger, Funktionsgruppen und Zugriffsprofile vor dem Absenden überprüfen.',
    [FunctionGroupRequestWizardTestIds.cardTitleSelectFunctionGroups]: null,
    [FunctionGroupRequestWizardTestIds.cardTitleWhoNeedsAccess]: null,
    [FunctionGroupRequestWizardTestIds.fgAssociationEditor]: 'Editor zum Hinzufügen, Entfernen und Vorschauen der ausgewählten Funktionsgruppen.',
    [FunctionGroupRequestWizardTestIds.reviewFgItem]: 'Ein einzelner Funktionsgruppen-Eintrag in der Prüfungsübersicht mit seinen Zugriffsprofilen.',
  },
}
